import { createSlice } from "@reduxjs/toolkit";

const stockSlice = createSlice({
  name: "stock",

  initialState: {
    purchases: null,
    sales: null,
    products: null,
    brands: null,
    firms: null,
    categories: null,
    loading: false,
    error: false,
  },
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = false;
    },
    getSuccess: (state, { payload: { data, url } }) => {
      state.loading = false;
      state[url] = data;
    },
    getProCatBrandsSuccess: (state, { payload }) => {
      state.loading = false;
      state.products = payload[0];
      state.categories = payload[1];
      state.brands = payload[2];
    },
    getAllStockSuccess: (state, { payload }) => {
      state.loading = false;
      state.purchases = payload[0];
      state.firms = payload[1];
      state.brands = payload[2];
      state.sales = payload[3];
      state.products = payload[4];
      state.categories = payload[5];
    },
    fetchFail: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});

export const {
  fetchStart,
  getSuccess,
  fetchFail,
  getProCatBrandsSuccess,
  getAllStockSuccess,
} = stockSlice.actions;
export default stockSlice.reducer;
